import { Navigate, useParams } from 'react-router-dom';
import { ROUTES } from '@/shared/constants/routes';

/** Compat: o piloto antigo usava `/meet/:meetingId`; o detalhe agora é `/meet/reunioes/:meetingId`. */
export default function MeetLegacyDetailRedirect() {
  const { meetingId = '' } = useParams();
  return <Navigate to={meetingId ? ROUTES.MEET_MEETING(meetingId) : ROUTES.MEET} replace />;
}
